import { useTranslation } from "@impero-com/common/utils/i18n";
import { RateGauge } from "@impero-com/ui";

import * as theme from "./ControlHealthDonutRateWidget.css";
import { ControlHealthWidget } from "./ControlHealthWidget";

interface ControlHealthOnTimeRateWidgetProps {
    onTimeRate: number | null;
}

export function ControlHealthOnTimeRateWidget({
    onTimeRate,
}: ControlHealthOnTimeRateWidgetProps) {
    const { t } = useTranslation();
    const percentage =
        onTimeRate === null ? null : Math.round(onTimeRate * 10) / 10;

    return (
        <ControlHealthWidget
            title={t("ControlHealth_OnTimeRate_Label")}
            className={theme.card}
        >
            <RateGauge
                percentage={percentage}
                label={t("ControlHealth_OnTimeRate_Label")}
            />
        </ControlHealthWidget>
    );
}
